export const useUtils = () => {

    return {
        getConnection(user) {
            return user.connection_sent_to_me || user.connection_received_from_me;
        }
    }
}
